import { upperFirst } from 'lodash';
import { toast } from 'react-toastify';

export const isSuccessResponseCode = (code, result) => {
  if (code !== '00000') {
    throw new Error(result);
  }

  toast.success(result);
};

export const isCreateResponseCode = (code, result) => {
  if (code !== '00003') {
    throw new Error(result);
  }
  toast.success(result);
};

export const isDeleteResponseCode = (code, result) => {
  if (code !== '00005') {
    throw new Error(result);
  }
  toast.success(result);
};

export const isUpdateResponseCode = (code, result) => {
  if (code !== '00004') {
    throw new Error(result);
  }
  toast.success(result);
};

export const transformBankListsData = (result) => {
  return result.map((value) => {
    return {
      id: value.banks_id,
      bank_name: value.bank_name,
      bank_shortname: value.bank_shortname,
      depository_banks: value.depository_banks,
      created_at: value.created_at,
    };
  });
};

export const transformAccountListsData = (result) => {
  return result.map((value) => {
    return {
      bank_account_id: value.bank_account_id,
      account_no: value.account_no,
      account_name: value.account_name === null ? 'N/A' : value.account_name,
      branch_type: upperFirst(value.branch_type),
      created_at: value.created_at,
    };
  });
};

export const transformBranchListsData = (result) => {
  return result.map((value) => {
    return {
      bank_branches_id: value.bank_branches_id,
      bank_branch_name: value.bank_branch_name,
      created_at: value.created_at,
      branch_type: upperFirst(value.branch_type),
    };
  });
};
